import * as React from 'react';
import Image from 'components/Image';
import Button from 'components/ButtonDeprecated';
import GoogleAPI from 'lib/GoogleAPI';
import AuthActions from 'auth/AuthActions';
import ToastActions from 'actions/ToastActions';
import LoadingModal from 'components/LoadingModal';

import './styles/GoogleSignIn.scss';

type Props = {
  body?: string;
  onSuccess?: () => void;
  mergeToken?: string | null;
  eventKey?: string;
};

class GoogleSignIn extends React.Component<
  Props,
  {
    loading: boolean;
  }
> {
  state: {
    loading: boolean;
  } = { loading: false };

  static defaultProps = {
    body: 'Log in with Google',
    onSuccess: () => undefined,
  };

  componentDidMount() {
    // Loads the Google API and initializes an auth instance so that the sign in flow becomes
    // synchronous. If the sign in button is clicked before the API is loaded, the Google sign
    // in popup will likely get blocked by a popup blocker.
    GoogleAPI.initWithAuthInstance();
  }

  handleAuthorizationCode = (code: string) => {
    this.setState({ loading: true });
    AuthActions.googleSignIn(code, this.props.mergeToken)
      .then(this.props.onSuccess)
      .catch(this.handleAuthorizationError);
  };

  handleAuthorizationError = () => {
    this.setState({ loading: false });
    ToastActions.showErrorToast(
      'There was an error logging in with Google. Please try again later.'
    );
  };

  handleClick = () => {
    GoogleAPI.fetchAuthorizationCode()
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '(code: string) => void' is not a... Remove this comment to see the full error message
      .then(this.handleAuthorizationCode)
      .catch(this.handleAuthorizationError);
  };

  render() {
    return (
      <div>
        {this.state.loading && <LoadingModal />}
        <Button
          type="button"
          color="paper"
          full
          level="secondary"
          className="GoogleSignIn"
          eventElementName="GoogleSignIn"
          onClick={this.handleClick}
          eventKey={this.props.eventKey}
        >
          <Image src={require('assets/images/superg.svg')} className="GoogleSignIn-logo" />
          {this.props.body}
        </Button>
      </div>
    );
  }
}

export default GoogleSignIn;
